<template>
  <el-form
    ref="addFrom"
    :model="addFrom"
    :rules="rules"
    label-width="110px"
    :hide-required-asterisk="false"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="课题属性" prop="ktsx">
          <el-select
            v-model="addFrom.ktsx"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择课题属性"
          >
            <el-option
              v-for="item in ktsxOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="所属阶段" prop="ssjd" :required="true">
          <el-select
            v-model="addFrom.ssjd"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择所属阶段"
          >
            <el-option
              v-for="item in ssjdOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="开始时间" prop="qsrq" key="10" :required="true">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="addFrom.qsrq"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="结束时间"
              prop="jsrq"
              key="10"
              :required="true"
            >
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="addFrom.jsrq"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-form-item label="关键物" prop="words" :required="true">
          <el-input
            v-model="addFrom.words"
            :clearable="true"
            :maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="负责人" prop="fzr" :required="true">
          <treeselect
            v-model="addFrom.fzr"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 100%; line-height: 18px; margin-top: 4px"
            :limit="1"
            :max-height="200"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { formatMomentDate, sizeFormat, checkVal } from "@/utils/utils";
import moment from "moment";
import { getDictData } from "@/api/task.js";
import { stepTimeSave } from "@/api/course.js";
export default {
  name: "timeAdd",
  computed: {
    ...mapGetters(["deptUser"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      rules: {
        ktsx: [
          { required: true, message: "课题属性不能为空", trigger: "change" },
        ],
        ssjd: [
          { required: true, message: "所属阶段不能为空", trigger: "change" },
        ],
        qsrq: [
          { required: true, message: "开始时间不能为空", trigger: "change" },
        ],
        jsrq: [
          { required: true, message: "结束时间不能为空", trigger: "change" },
        ],
        words: [{ required: true, message: "关键物不能为空", trigger: "blur" }],
        fzr: [{ required: true, message: "负责人不能为空", trigger: "change" }],
      },
      addFrom: {
        ktsx: null,
        ssjd: null,
        qsrq: null,
        jsrq: null,
        words: null,
        fzr: null,
      },
      ktsxOptions: [],
      ssjdOptions: [],
      parentDialog: false,
    };
  },

  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    //课题属性
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        this.ktsxOptions = res.data;
      }
    });
    //所属阶段
    getDictData("pmp_course_step", 1).then((res) => {
      if (res.code === 0) {
        this.ssjdOptions = res.data;
      }
    });
    this.addFrom.qsrq = moment().add("d");
    this.addFrom.jsrq = moment().add(1, "d");
  },
  methods: {
    handleAdd() {
      this.$refs["addFrom"].validate((valid) => {
        if (valid) {
          let type = 0;
          let qsrq = formatMomentDate(new Date(this.addFrom.qsrq));
          let jsrq = formatMomentDate(new Date(this.addFrom.jsrq));
          if (qsrq > jsrq) {
            this.$message.error("开始时间不能大于结束时间！");
            return false;
          }
          const params = { ...this.addFrom, qsrq, jsrq, type };
          stepTimeSave(params).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("giveFather", this.parentDialog);
            } else {
              if (res.msg) {
                this.$message.error(res.msg);
              } else {
                this.$message.error("保存参数异常！");
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
</style>